export default __webpack_public_path__ + "static/media/TreeAssessments.e7c153ff.jpg";